import * as React from "react";
import { AgencyId } from "../messages/ObjectIds";
import { STRINGS } from "../strings";
import { Agency } from "../system/AppState/AppAgenciesState";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";
import { translate } from "../translate";
import { fmap } from "../utils/fmap";
import { HashMap } from "../utils/HashMap";
import ContactSupportList from "./ContactSupportList";
import { AppAbstractModal } from "./Generic/AppModal/AppAbstractModal";
import ModalHeadline from "./Generic/AppModal/components/ModalHeadline/ModalHeadline";

interface ContactSupportModalProps {
  caregiver: AppCaregiver;
  agencies: HashMap<AgencyId, Agency>;
  isOpen: boolean;
  getAnomalies: (noEncode: boolean) => Promise<string>;
  onClickChatSupport: () => void;
  onRequestClose?: () => void;
}

const ContactSupportModal = (props: ContactSupportModalProps) => {
  const onClickChatSupport = () => {
    props.onClickChatSupport();
    fmap(props.onRequestClose, (onRequestClose) => onRequestClose());
  };

  return (
    <AppAbstractModal
      className="ContactSupportModal"
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
    >
      <ModalHeadline>{translate(STRINGS.CONTACT_SUPPORT)}</ModalHeadline>
      <ContactSupportList
        agencies={props.agencies}
        caregiver={props.caregiver}
        getAnomalies={props.getAnomalies}
        onClickChatSupport={onClickChatSupport}
      />
    </AppAbstractModal>
  );
};

export default React.memo(ContactSupportModal);
